/**
 * en-GB messages added by Phase 2 task M2 (docs/PHASE-2-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 */
export const m2EnGB = {
    'companion.common.back': 'Back',
    'companion.common.loading': 'Loading...',
    'companion.common.retry': 'Try again',
    'companion.common.cancel': 'Cancel',
    'companion.common.save': 'Save',
    'companion.common.done': 'Done',
    'companion.common.offline': 'No connection. We will keep trying.',
    'companion.common.empty': 'Nothing to show yet.',
    'companion.common.remote': 'Working remotely',
    'companion.common.today': 'Today',
    'companion.common.tomorrow': 'Tomorrow',
    // Start
    'companion.start.title': 'Welcome to CloudSign',
    'companion.start.intro': 'Sign in and out of work from your phone. Use the email invite from your organisation, or ask for a new link below.',
    'companion.start.revoked': 'This phone has been signed out by your organisation. Ask for a new link to sign in again.',
    'companion.start.signed_out': 'You have signed out of this phone.',
    'companion.start.email_label': 'Your work email address',
    'companion.start.email_button': 'Email me a link',
    'companion.start.email_sent': 'If that address is set up, a sign-in link is on its way. Open it on this phone.',
    'companion.start.email_invalid': 'Please enter a valid email address.',
    'companion.start.scan_button': 'Scan the invite QR code',
    'companion.start.scan_help': 'Point the camera at the QR code in your invite.',
    'companion.start.scan_denied': 'The camera is turned off for this app. Turn it on in your phone settings, or paste the link instead.',
    'companion.start.scan_close': 'Close camera',
    'companion.start.paste_label': 'Or paste your invite link',
    'companion.start.paste_button': 'Use this link',
    // Lock
    'companion.lock.title': 'CloudSign is locked',
    'companion.lock.pin_label': 'Enter your PIN',
    'companion.lock.unlock': 'Unlock',
    'companion.lock.biometric': 'Use fingerprint or face',
    'companion.lock.pin_wrong': 'That PIN did not work. After several wrong tries you must wait 30 seconds.',
    'companion.lock.forgot': 'Forgot your PIN? Sign out of this phone',
    // Home
    'companion.home.greeting': 'Hi {name}',
    'companion.home.subtitle': '{group} at {tenant}',
    'companion.home.status_in': 'Signed in at {site}',
    'companion.home.status_in_since': 'Since {time}',
    'companion.home.status_out': 'You are signed out',
    'companion.home.status_out_note': 'You are marked as out today. Sign in when you arrive.',
    'companion.home.choose_site': 'Where are you?',
    'companion.home.sign_in': 'Sign in',
    'companion.home.sign_in_at': 'Sign in at {site}',
    'companion.home.sign_out': 'Sign out',
    'companion.home.working': 'One moment...',
    'companion.home.done_in': 'You are signed in.',
    'companion.home.done_out': 'You are signed out.',
    'companion.home.pending': 'Your sign-in has been received and is waiting for approval.',
    'companion.home.rejected': 'That could not be done.',
    'companion.home.menu_qr': 'My QR code',
    'companion.home.menu_history': 'My sign-ins',
    'companion.home.menu_today': 'Who is in today',
    'companion.home.menu_visitors': 'My visitors',
    'companion.home.menu_settings': 'Settings',
    'companion.home.no_sites': 'There are no sites available to you yet.',
    'companion.home.not_allowed': 'Your organisation has not turned on signing in from the app.',
    // QR
    'companion.qr.title': 'My QR code',
    'companion.qr.help': 'Hold this up to the scanner at the sign-in screen to sign in or out.',
    'companion.qr.brightness': 'Turn your screen brightness up so it scans easily.',
    'companion.qr.label': 'QR code for signing in at the sign-in screen',
    // History
    'companion.history.title': 'My sign-ins',
    'companion.history.in': 'In {time}',
    'companion.history.out': 'Out {time}',
    'companion.history.still_in': 'Still signed in',
    'companion.history.more': 'Show older',
    'companion.history.method_app': 'Phone',
    'companion.history.method_qr': 'QR code',
    'companion.history.method_geofence': 'Location',
    'companion.history.method_kiosk': 'Sign-in screen',
    'companion.history.method_other': 'Other',
    // Today
    'companion.today.title': 'Who is in today',
    'companion.today.count': '{count} in',
    'companion.today.visitor_of': 'Visitor, hosted by {host}',
    'companion.today.visitor': 'Visitor',
    'companion.today.since': 'Since {time}',
    // Visitors
    'companion.visitors.title': 'My visitors',
    'companion.visitors.add': 'Pre-register a visitor',
    'companion.visitors.expected': 'Expected {time}',
    'companion.visitors.status.pending_approval': 'Waiting for approval',
    'companion.visitors.status.expected': 'Expected',
    'companion.visitors.status.arrived': 'Has arrived',
    'companion.visitors.status.cancelled': 'Cancelled',
    'companion.visitors.status.no_show': 'Has not arrived',
    'companion.visitors.status.rejected': 'Not approved',
    'companion.visitors.arrived_banner': 'Your visitor has arrived',
    'companion.visitors.on_my_way': 'On my way',
    'companion.visitors.please_wait': 'Please wait',
    'companion.visitors.reply_sent': 'Sent: {reply}',
    'companion.visitors.running_late': 'Running late',
    'companion.visitors.cancelled': 'Cancelled',
    'companion.visitors.answer_sent': 'Sent: {answer}',
    'companion.visitors.progress_opened': 'Opened the link',
    'companion.visitors.progress_confirmed': 'Confirmed they are coming',
    'companion.visitors.progress_answers': 'Answered the questions',
    'companion.visitors.progress_notices': 'Accepted notices ({done} of {total})',
    'companion.visitors.progress_photo': 'Added a photo',
    'companion.visitors.progress_car': 'Car registration {reg}',
    'companion.visitors.progress_none': 'Has not opened the link yet',
    // Pre-register
    'companion.prereg.title': 'Pre-register a visitor',
    'companion.prereg.name': 'Visitor name',
    'companion.prereg.email': 'Visitor email (optional)',
    'companion.prereg.phone': 'Visitor phone (optional)',
    'companion.prereg.company': 'Company (optional)',
    'companion.prereg.site': 'Site',
    'companion.prereg.day': 'Day',
    'companion.prereg.time': 'Time (24 hour, like 09:30)',
    'companion.prereg.notes': 'Notes (optional)',
    'companion.prereg.send_email': 'Email the visitor their details',
    'companion.prereg.submit': 'Pre-register',
    'companion.prereg.done': 'Done. {name} is expected.',
    'companion.prereg.err_name': 'Please enter the visitor name.',
    'companion.prereg.err_email': 'That email address does not look right.',
    'companion.prereg.err_time': 'Please enter the time like 09:30.',
    'companion.prereg.err_site': 'Please choose a site.',
    'companion.prereg.err_group': 'This cannot be done from the app yet. Please ask your administrator.',
    // Settings
    'companion.settings.title': 'Settings',
    'companion.settings.account': 'Signed in as {name}',
    'companion.settings.lock_title': 'App lock',
    'companion.settings.lock_on': 'A PIN is set. The app asks for it after you have been away for a minute.',
    'companion.settings.lock_off': 'No PIN is set.',
    'companion.settings.lock_required': 'Your organisation requires the app lock, so it cannot be turned off.',
    'companion.settings.lock_set': 'Set a PIN',
    'companion.settings.lock_change': 'Change PIN',
    'companion.settings.lock_remove': 'Turn off the lock',
    'companion.settings.lock_now': 'Lock now',
    'companion.settings.lock_biometric': 'Your fingerprint or face can also unlock the app.',
    'companion.settings.pin_new': 'New PIN (4 to 6 digits)',
    'companion.settings.pin_confirm': 'Type the PIN again',
    'companion.settings.pin_mismatch': 'The two PINs are not the same.',
    'companion.settings.pin_saved': 'Your PIN is saved.',
    'companion.settings.notifications_title': 'Notifications',
    'companion.settings.notifications_enabled': 'On. You will be told when a visitor arrives.',
    'companion.settings.notifications_disabled': 'Off. Turn them on in your phone settings to hear when a visitor arrives.',
    'companion.settings.notifications_unavailable': 'Not available in this version of the app yet.',
    'companion.settings.notifications_unknown': 'Checking...',
    'companion.settings.location_title': 'Location',
    'companion.settings.location_notice': 'If you agree, CloudSign can use your phone location to sign you in and out at your site. It is never used when you are signed out of work.',
    'companion.settings.location_agree': 'I agree',
    'companion.settings.location_withdraw': 'Withdraw my agreement',
    'companion.settings.location_given': 'You have agreed.',
    'companion.settings.location_not_given': 'You have not agreed.',
    'companion.settings.sign_out': 'Sign out of this phone',
    'companion.settings.sign_out_confirm': 'Sign out of this phone? You will need a new link to sign in again.',
    'companion.settings.sign_out_yes': 'Sign out',
};
//# sourceMappingURL=m2.js.map